import SuccessSummary from './success';
import FailedSummary from './failed';
import { useMainState } from '@pages/AuditTrailSellOut/state/state';

export default function Summary() {
    const { selectedAuditTrail } = useMainState();

    const isFailed = selectedAuditTrail?.status === 'failed';
    return isFailed ? <FailedSummary /> : <SuccessSummary />;
}
